// @file Entrypoint for no access page
import { captureException } from '@@/bits/error_tracker'
import window from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import AccessRequestApp from '@@/vuecomponents/AccessRequestApp.vue'
import { configure as configureArvo } from '@padlet/arvo'

// Configure arvo for fetching user a11y settings
const { arvoConfig } = window.ww.vueStartingState
void configureArvo(arvoConfig)

void setupVueApp({
  el: '#access_request',
  rootComponent: AccessRequestApp,
  rootComponentProps: () => window.ww.vueStartingState,
  usePinia: true, // for global snackbar and accessibility settings store
})
  .then((vueInstance) => {
    window.app = vueInstance
  })
  .catch(captureException)
